import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bool',
})
export class BoolPipe implements PipeTransform {
  transform(value: any): any {
    if (typeof value === 'boolean') {
      return value ? $localize`Tak` : $localize`Nie`;
    }
    return value;
  }
}
